import { RouterLink } from '@angular/router';
import { NgClass, NgIf } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { AppSettings } from '@Shared/app.settings';
import { ScreenSizeService } from '@Shared/services';
import { PitchCardService } from '../../services';
import { PitchCardTypeEnum } from '@App/common/enums';
import { VideoErrorsConfig } from '../../interfaces';
import { VideoUploadComponent } from '../../components/video-upload/video-upload.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-upload-video-steps',
  templateUrl: './upload-video-steps.component.html',
  imports: [TranslateModule, VideoUploadComponent, NgClass, NgIf, RouterLink],
  standalone: true,
  encapsulation: ViewEncapsulation.None
})
export class UploadVideoComponent implements OnDestroy {
  @Output() next: EventEmitter<any> = new EventEmitter();

  @Input() businessType: string = 'basic';

  uploadedFiles: any[] = [];
  errorMessage: string = '';
  formats: string = AppSettings.AcceptableVideoFormats;
  isShowVideoFormat: boolean;
  isMobile: boolean;
  errorConfig: VideoErrorsConfig;
  PitchCardTypes = PitchCardTypeEnum;

  constructor(
    private screenSizeService: ScreenSizeService,
    private pitchCardService: PitchCardService
  ) {
    this.isMobile = this.screenSizeService.isMobile;
    this.errorConfig = this.pitchCardService.videoReviewsErrorConfig();
  }

  ngOnDestroy() {
    this.uploadedFiles = [];
    this.errorMessage = '';
  }

  postUpload({ uploadedFiles }: any) {
    this.uploadedFiles = uploadedFiles;
    this.errorMessage = '';

    if (this.uploadedFiles.length) {
      this.next.emit({
        uploadedFiles: this.uploadedFiles
      });
    }
  }

  errorInVideoUpload(event: string) {
    this.errorMessage = event;
  }

  showFormat() {
    this.isShowVideoFormat = !this.isShowVideoFormat;
  }
}
